import * as yup from 'yup';

export const APPLICANT_EMAIL_INVALID = 'Invalid email';
export const APPLICANT_EMAIL_UNIQUE = 'Applicant emails need to be unique';
export const APPLICANT_EMAIL_UNIQUE_IGNORING_CASE =
  'Applicant emails need to be unique (ignoring case)';

export const applicantEmailValidate = yup.string().email(APPLICANT_EMAIL_INVALID);

type ApplicantEmailRow = { email?: string; is_deleted?: boolean };

// Array-level case-insensitive uniqueness. Per-entry required/format rules stay
// on the email field. This is the invite-create check: one error on the array.
export const applicantsUniqueValidate = yup
  .array()
  .test('unique', APPLICANT_EMAIL_UNIQUE, function (values, { createError }) {
    const entries = values as ApplicantEmailRow[] | undefined;
    if (!entries?.length) {
      return true;
    }
    const emails = entries.map(({ email }) => (email ?? '').toLowerCase());
    const hasDuplicate = new Set(emails).size !== emails.length;
    return hasDuplicate
      ? createError({ path: 'applicants', message: APPLICANT_EMAIL_UNIQUE_IGNORING_CASE })
      : true;
  });

// Same uniqueness rule, attached to the later duplicate row. Deleted rows and
// blank emails are skipped so a staged removal does not collide with itself.
export const applicantEmailsUniqueByRowValidate = yup
  .array()
  .test('unique-by-row', APPLICANT_EMAIL_UNIQUE, (values, testContext) => {
    const entries = values as ApplicantEmailRow[] | undefined;
    if (!entries?.length) {
      return true;
    }
    const seen = new Set<string>();
    for (let index = 0; index < entries.length; index += 1) {
      const row = entries[index];
      if (row?.is_deleted) {
        continue;
      }
      const email = (row?.email ?? '').trim().toLowerCase();
      if (!email) {
        continue;
      }
      if (seen.has(email)) {
        return testContext.createError({
          path: `${testContext.path}.${index}.email`,
          message: APPLICANT_EMAIL_UNIQUE_IGNORING_CASE,
        });
      }
      seen.add(email);
    }
    return true;
  });
